import React from 'react';
import { Hidden } from '@mui/material';

type Props = {
    content: React.ReactNode;
};

const DesktopMobileSwitcher: React.FC<Props> = ({ content }) => (
    <>
        <Hidden mdDown>{content}</Hidden>
    </>
);

export default React.memo(DesktopMobileSwitcher);
